import { IApplicationState } from '../../../../../types/types'
import { IChecklists } from '../types';

export const getChecklists = (
    state: IApplicationState
): IChecklists => {
    return state.model.checklists || {};
};
